const Preconditions = {
  CustomerRecordNameIsIndividual: 1,
  LegalOrSoleOwnerIsIndividual: 2,
  CustomerRecordNameIsDRE: 3
};

export default Preconditions;
